/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error } }) => {
  if (loading) {
    return <Spinner message={t("settings.collections.messages.loading")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p> {t("settings.collections.messages.not_loading")} </p>
        </React.Fragment>
      );
    }
  }

  return <p>{t("settings.collections.messages.unknown-error")}</p>;
};

export default Loader;
